import { useSelector } from "react-redux";

export default function useCurrency() {
  const businessCurrencies = useSelector((state: any) => state.currencyReducer.businessCurrencies);
  const allCurrencies = useSelector((state: any) => state.currencyReducer.currencies);
  const defCurId: number = useSelector((state: any) => state.businessReducer?.business?.business?.default_currency_id);
  const defCur = allCurrencies.find((x:any) => x.id === defCurId) || allCurrencies[0];
let c = [...[defCur], ...businessCurrencies];
  const currencies = c.map((x) => ({
    ...x,
    label: x.id === 1 ? "IRR - ریال ایران" : `${x.en_title} - ${x.fa_title}`,
    value: x.id,
  }));
  const shortCurrencies = c.map((x) => ({
    ...x,
    label: x.id === 1 ? "ریال" : `${x.fa_title}`,
    value: x.id,
  }));

  function change(from: string, to: string, val: number) {
    const fromCurrency = c.find((x: any) => x.en_title === from);
    const toCurrency = c.find((x: any) => x.en_title === to);
    const FCR = fromCurrency?.currencyExchange || 1;
    const TCR = toCurrency?.currencyExchange || 1;
    return (val * FCR) / TCR;
  }

  return { change, defCur, currencies, shortCurrencies };
}
